<template>
	<div style="min-height:70vh">
    <!-- <div class="code-btn">
      <button  @click="produceCode">
        產生序號
      </button>
    </div> -->
    <label-tag v-on:createCode="produceCode" :tagArray="[$t('list_of_students')]"/>
    <div class="m-5" style="overflow: auto; min-height:70vh">
			<table class="table table-borderless table-hover">
				<thead>
					<tr>
						<th>{{$t('student_id')}}</th>
						<th>{{$t('name')}}</th>
            <th>{{$t('selected')}} <span @click="selectedAll" v-model="checkedAll" style="color:blue; font-size:1rem;cursor: pointer;">{{$t('all_selected')}}</span></th>
            <th>{{$t('your_serial_number')}}</th>
            <th>{{$t('valid_time')}}</th>
					</tr>
				</thead>
				<tbody style="border-top:1px #cccccc solid;border-bottom:1px #cccccc solid;text-align: left;">
					<tr v-for="(item, index) in list" :key="index">
            <td>
							{{item.studentNo}}
						</td>
            <td>
							{{item.realName}}
						</td>
            <td>
              <input @click="selectedStudent(item.id)" v-model="item.checked" type="checkbox" name="" id="">
            </td>
            <td>
              {{item.code}}
            </td>
            <td>
              {{item.effective}}
            </td>
					</tr>
				</tbody>
			</table>
		</div>
    <pagination :current="pageIndex" :total="pageCount" v-on:page="getList" />
	</div>
</template>

<script>
import pagination from './Pagination'
import labelTag from './Label'
import api from '../../../store/api.js'
export default {

  name: 'StudentList',

  data () {
    return {
      list: [],
      selectedList: [],
      pageIndex: 1,
      pageCount: 0,
      pageSize: 50,
      checkedAll: false
    }
  },
  components: {
    labelTag,
    pagination
  },
  mounted () {
    this.getList()
  },
  methods: {
    async getList (page) {
      page = page || 1
      const { data } = await api.get(`/GroupMgr/TeachingGroups/${this.$route.params.id}/Students`, { params: { pageIndex: page, pageSize: this.pageSize } })
      this.list = data.data
      this.pageIndex = data.pageIndex
      this.pageCount = data.pageCount
    },
    async produceCode () {
      let formData = new window.FormData()
      this.selectedList.map((el) => {
        formData.append('userIds', el)
      })
      const { data } = await api.post(`/VR/AccessCode`, formData)
      let codeList = data.data
      if (codeList) {
        for (let item in codeList) {
          this.list = this.list.map((el, index) => {
            if (el.id === codeList[item].id) {
              el.code = codeList[item].accessCode
              el.effective = codeList[item].expreTime
            }
            return el
          })
        }
      }
      await this.export2Excel(this.list)
    },
    selectedStudent (id) {
      let index = this.selectedList.indexOf(id)
      if (index === -1) {
        this.selectedList.push(id)
      } else {
        this.selectedList.splice(index, 1)
      }
    },
    selectedAll () {
      this.checkedAll = !this.checkedAll
      this.list.map((el) => {
        el.checked = this.checkedAll
        if (this.checkedAll) {
          this.selectedList.push(el.id)
        } else {
          this.selectedList = []
        }
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    export2Excel (list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../../vendor/Export2Excel')
        const tHeader = [ '學號', '姓名', '有效時間', '序號' ]
        const filterVal = [ 'studentNo', 'realName', 'effective', 'code' ]
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '序號列表')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/color.scss";
  table {
    table-layout : fixed;
    font-size: 1.25rem;
  }
</style>


// WEBPACK FOOTER //
// StudentList.vue?0535494d